var _style, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryStuff = function SvgCategoryStuff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_stuff_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_stuff_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_stuff_svg__st0",
    d: "m15 23.6 4.9-11.9h8.2l4.8 11.9H22.7zM19.6 36.5l2.7-3c.1-.2.3-.3.5-.3H25c.2 0 .3.1.5.2l2.8 3c.4.4.1 1.1-.5 1.1h-7.7c-.6.1-.8-.6-.5-1zM22.7 32.6v-8.5M25 32.6v-8.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "category_stuff_svg__st0",
    cx: 28.9,
    cy: 29,
    r: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "category_stuff_svg__st0",
    d: "M28.9 23.6v3.7"
  })));
};
export default SvgCategoryStuff;